import React from 'react';
import { useNavigate } from 'react-router-dom';
import './EmptyState.css';

const EmptyState = ({
  icon = '📋',
  title,
  message,
  requirements = [],
  primaryAction,
  primaryActionLabel,
  secondaryAction,
  secondaryActionLabel,
  hint,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleAction = (action) => {
    if (typeof action === 'function') {
      action();
    } else if (typeof action === 'string') {
      navigate(action);
    }
  };

  const allRequirementsMet = requirements.length === 0 || requirements.every(req => req.completed);

  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">{title}</h3>
      
      {message && (
        <p className="empty-state-message">{message}</p>
      )}

      {requirements.length > 0 && (
        <div className="empty-state-requirements">
          <p className="requirements-title">Requisitos necesarios:</p>
          <ul className="requirements-list">
            {requirements.map((req, index) => (
              <li key={index} className={`requirement-item ${req.completed ? 'completed' : 'pending'}`}>
                <span className="requirement-icon">
                  {req.completed ? '✅' : '⏳'}
                </span>
                <span className="requirement-text">{req.text}</span>
                {!req.completed && req.action && (
                  <button
                    className="btn btn-link btn-sm requirement-action"
                    onClick={() => handleAction(req.action)}
                  >
                    {req.actionLabel || 'Crear'}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {hint && (
        <p className="empty-state-hint">{hint}</p>
      )}

      <div className="empty-state-actions">
        {primaryAction && allRequirementsMet && (
          <button
            className="btn btn-primary"
            onClick={() => handleAction(primaryAction)}
          >
            {primaryActionLabel || 'Crear'}
          </button>
        )}
        {secondaryAction && (
          <button
            className="btn btn-secondary"
            onClick={() => handleAction(secondaryAction)}
          >
            {secondaryActionLabel || 'Ver más'}
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;

